/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#c9c8c8',
        borderColor: '#c9c8c8',
        color: '#000000',
        fontName: 'StagSans',
        fontWeight: '600',
        outerBorderColor: '#c9c8c8'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderColor: '#000000',
        borderWidth: 0,
        outerBorderColor: '#000000',
        outerBorderWidth: 3
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        backgroundColor: '#595959',
        borderColor: '#595959',
        borderWidth: 1,
        color: '#c9c8c8'
      }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        color: '#ffffff',
        outerBorderColor: '#404040'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#595959',
        borderColor: '#595959',
        borderWidth: 1,
        color: '#c9c8c8',
        outerBorderColor: '#595959'
      }
    },
    {
      if: { viewport: [ 'xs', 'sm', 'md' ] },
      tokens: { textAlign: 'space-between', width: 288 }
    },
    { if: { viewport: [ 'lg', 'xl' ] }, tokens: { borderRadius: 32 } },
    {
      if: { hover: true, selected: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        color: '#ffffff',
        fontName: 'StagSans',
        fontWeight: '600'
      }
    },
    {
      if: { pressed: true, selected: true },
      tokens: {
        backgroundColor: '#595959',
        borderColor: '#595959',
        color: '#c9c8c8',
        fontName: 'StagSans',
        fontWeight: '600',
        outerBorderColor: '#595959'
      }
    },
    {
      if: { expanded: true },
      tokens: { icoMenu: PaletteIconChevronUp }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    borderWidth: 0,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 14,
    fontWeight: '600',
    icoMenu: PaletteIconChevronDown,
    lineHeight: 1.45,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: '#c9c8c8',
    outerBorderGap: 0,
    outerBorderWidth: 1,
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 6,
    shadow: null,
    textAlign: 'center',
    width: 0
  }
}
export default theme
